import useResource from './useResource';

const useEarnItems = () => {
	const RESOURCE_URL = '/api/v1/admin/earn-items';

	const {
		isLoading,
		isEmpty,
		isEditing,
		resource: earnItem,
		resources: earnItems,
		findOne: findEarnItem,
		findMany: findEarnItems,
		update: updateEarnItem,
		create: createEarnItem,
		save: saveEarnItem,
		destroy: deleteEarnItem,
		handleChange,
		reloadMany: reloadEarnItems,
		reloadOne: reloadEarnItem
	} = useResource({
		id: null,
		url: RESOURCE_URL,
		name: 'earn_item'
	});

	return {
		isLoading,
		isEmpty,
		isEditing,
		earnItem,
		earnItems,
		findEarnItem,
		findEarnItems,
		updateEarnItem,
		createEarnItem,
		saveEarnItem,
		deleteEarnItem,
		handleChange,
		reloadEarnItems,
		reloadEarnItem
	};
};

export default useEarnItems;
